<template>
    <transition :name="transitionName">
        <div v-show="visible" :style="customStyle" class="back-to-ceiling" @click="backToTop"
             @mouseleave="mouseleave" @mouseenter="mouseenter">
            <i class="el-icon-upload2" style="cursor: pointer; font-size: 20px"></i>
        </div>
    </transition>
</template>

<script>
    export default {
        name: 'BackToTop',
        props: {
            visibilityHeight: {
                type: Number,
                default: 300
            },
            backPosition: {
                type: Number,
                default: 0
            },
            el: {                   //此组件需要知道当前全屏组件的ID，以获取对应的滚动条
                default() {
                    return window;
                },
            },
            customStyle: {
                type: Object,
                default() {
                    return {
                        right: '50px',
                        bottom: '50px',
                        width: '50px',
                        height: '40px',
                        'border-radius': '4px',
                        'line-height': '40px',
                        background: '#e7eaf1',
                        'box-shadow': '0 0 20px #7F7F85',
                    };
                }
            },
            transitionName: {
                type: String,
                default: 'fade'
            }
        },
        data() {
            return {
                visible: false,
                interval: null,
                isMoving: false
            }
        },
        mounted() {
            this.el.addEventListener('scroll', this.handleScroll);
        },
        beforeDestroy() {
            this.el.removeEventListener('scroll', this.handleScroll);
            if (this.interval) {
                clearInterval(this.interval);
            }
        },
        methods: {
            handleScroll() {
                if (this.el != window) {
                    this.visible = this.el.scrollTop > this.visibilityHeight;
                } else {
                    this.visible = this.el.pageYOffset > this.visibilityHeight;
                }
            },

            backToTop() {
                if (this.isMoving) return;
                let start;
                if (this.el != window) {
                    start = this.el.scrollTop;
                } else {
                    start = this.el.pageYOffset;
                }
                let i = 0;
                this.isMoving = true;
                this.interval = setInterval(() => {
                    const next = Math.floor(this.easeInOutQuad(10 * i, start, -start, 500));
                    if (next <= this.backPosition) {
                        this.el.scrollTo(0, this.backPosition);
                        clearInterval(this.interval);
                        this.isMoving = false;
                    } else {
                        this.el.scrollTo(0, next);
                    }
                    i++
                }, 16.7)
            },

            easeInOutQuad(t, b, c, d) {
                if ((t /= d / 2) < 1) return c / 2 * t * t + b;
                return -c / 2 * (--t * (t - 2) - 1) + b;
            },

            mouseleave() {
                $('.el-icon-upload2')[0].style = 'color: black; font-size: 20px';
            },

            mouseenter() {
                $('.el-icon-upload2')[0].style = 'color: #1B7FAA; font-size: 20px';
            },
        }
    }
</script>

<style scoped>
    .back-to-ceiling {
        position: fixed;
        display: inline-block;
        text-align: center;
        cursor: pointer;
    }

    .back-to-ceiling:hover {
        background: #d5dbe7;
    }
</style>
